import gql from 'graphql-tag';

export default gql`
  fragment sensorSettingsFields on DeviceSensorSettings {
    enabled
    motionNotDetectedAction {
      intent
      mode {
        ...lightModeFields
      }
      dimming
    }
    motionNotDetectedDelay
    motionDetectedAction {
      intent
      mode {
        ...lightModeFields
      }
      dimming
    }
    detectionDelayEnabled
    detectionDelay
    luxThreshold
  }
`;
